import PropTypes from 'prop-types';
import React from 'react';
import Rodal from 'rodal';
import styled from 'react-emotion';
import { withRouter } from 'react-router-dom';

import Button from '../../Buttons/Button';
import eventCreatedIcon from '../../../assets/images/icons/event-created.svg';
import { H1 } from '../../Text/Text';
import Style from '../../../styles/common';
import { TIER } from '../../Buttons/constants';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

const Content = styled('div')`
  text-align: center;
`;

const Heading = styled(H1)`
  margin-top: ${Style.SPACING.L};
`;

const Buttons = styled('div')`
  display: flex;
  justify-content: center;
  margin-top: ${Style.SPACING.XXL};
`;

const ButtonContainer = styled('div')`
  margin-right: ${Style.SPACING.XS};
`;

function SuccessModal(props) {
  return (
    <Rodal
      height={400}
      onClose={props.onClose}
      visible={props.visible}
      width={500}
    >
      <Container>
        <Content>
          <img src={eventCreatedIcon} />
          <Heading>{props.title}</Heading>
          <Buttons>
            <ButtonContainer>
              <Button onClick={navigateToEvent}>View your event</Button>
            </ButtonContainer>
            <Button
              onClick={props.onClose}
              tier={TIER.SECONDARY}
            >
              {props.continueText}
            </Button>
          </Buttons>
        </Content>
      </Container>
    </Rodal>
  );

  function navigateToEvent() {
    props.history.push(`/event/${props.eventId}`);
  }
}

SuccessModal.propTypes = {
  continueText: PropTypes.string.isRequired,
  eventId: PropTypes.string.isRequired,
  isVisible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

SuccessModal.defaultProps = {
  isVisible: false,
};

export default withRouter(SuccessModal);



// WEBPACK FOOTER //
// ./src/components/Modals/SuccessModal/SuccessModal.js